/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_Saved_FilesInputs */

const es_feedback_modal_saved_files = /** @type {(inputs: Feedback_Modal_Saved_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivos guardados`)
};

const en_feedback_modal_saved_files = /** @type {(inputs: Feedback_Modal_Saved_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved files`)
};

/**
* | output |
* | --- |
* | "Saved files" |
*
* @param {Feedback_Modal_Saved_FilesInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_saved_files = /** @type {((inputs?: Feedback_Modal_Saved_FilesInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_Saved_FilesInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_saved_files(inputs)
	return en_feedback_modal_saved_files(inputs)
});
export { feedback_modal_saved_files as "feedback.modal.saved_files" }